module.exports = __webpack_public_path__ + "static/media/page_not_found_icon.b1dd0e74.svg";